// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../../common/Components/Form.bs.js");
let Form__Label = require("../../common/Components/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Options__PropertyType = require("../../../reason/common/types/options/Options__PropertyType.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let Options__RentalPropertyType = require("../../../reason/common/types/options/Options__RentalPropertyType.bs.js");
let PropertyWizardRelayKeyFactsPropertyType_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPropertyType_draft_graphql.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");
let PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes = require("./PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let DraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let DraftFragment = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__PropertyType(props) {
  let stepHasBeenTouched = props.stepHasBeenTouched;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = draft.draftProperty;
  let rentalPropertyType = draftProperty.rentalPropertyType;
  let forSalePropertyType = draftProperty.forSalePropertyType;
  let isPropertyTypeValid = PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.PropertyType.useIsValid(draft.fragmentRefs);
  let forSalePropertyTypeOption = Stdlib_Option.map(forSalePropertyType, Options__PropertyType.make);
  let rentalPropertyTypeOption = Stdlib_Option.map(rentalPropertyType, Options__RentalPropertyType.make);
  let forSalePropertyType$1 = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.forSalePropertyType = value;
      return newrecord;
    }
  }, stepHasBeenTouched, forSalePropertyType, isPropertyTypeValid);
  let rentalPropertyType$1 = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.rentalPropertyType = value;
      return newrecord;
    }
  }, stepHasBeenTouched, rentalPropertyType, isPropertyTypeValid);
  let tmp;
  if (draftProperty.propertyType === "FOR_SALE") {
    let match = forSalePropertyType$1.valid;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
          getOptionLabel: Options__PropertyType.getOptionLabel,
          getOptionValue: Options__PropertyType.getOptionValue,
          isClearable: true,
          onBlur: param => forSalePropertyType$1.onBlur(),
          onChange: value => forSalePropertyType$1.onChange(value !== undefined ? value.value : undefined),
          options: Options__PropertyType.defaultOptions,
          value: forSalePropertyTypeOption,
          status: match !== undefined ? (
              typeof match === "object" ? "Failure" : "Success"
            ) : "Neutral"
        }),
        JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: forSalePropertyType$1.valid
        })
      ]
    });
  } else {
    let match$1 = rentalPropertyType$1.valid;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
          getOptionLabel: Options__RentalPropertyType.getOptionLabel,
          getOptionValue: Options__RentalPropertyType.getOptionValue,
          isClearable: true,
          onBlur: param => rentalPropertyType$1.onBlur(),
          onChange: value => rentalPropertyType$1.onChange(value !== undefined ? value.value : undefined),
          options: Options__RentalPropertyType.defaultOptions,
          value: rentalPropertyTypeOption,
          status: match$1 !== undefined ? (
              typeof match$1 === "object" ? "Failure" : "Success"
            ) : "Neutral"
        }),
        JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: rentalPropertyType$1.valid
        })
      ]
    });
  }
  return JsxRuntime.jsx(Form.Section.make, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
      children: [
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          widthMd: 4,
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Property Type"
            }),
            tmp
          ]
        }),
        JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes.make, {
          draft: draft.fragmentRefs,
          stepHasBeenTouched: stepHasBeenTouched
        })
      ]
    })
  });
}

let Components;

let FormSection;

let Grid;

let Cell;

let PropertyAttributes;

let Validators;

let FormUtils;

let FormControl;

let make = PropertyWizardRelay__KeyFacts__PropertyType;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.PropertyAttributes = PropertyAttributes;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.FormControl = FormControl;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form Not a pure module */
